import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/LegalPage'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class LegalPageStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "LegalPageStore",
			variables: true,
		})
	}
}

export async function load_LegalPage(params) {
	await initClient()

	const store = new LegalPageStore()

	await store.fetch(params)

	return {
		LegalPage: store,
	}
}
